import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowServiceTypeActionsMenu = ({
  row,
  onEdit,
  onDelete,
  onCreateServiceCharge,
  onViewServiceCharges,
  hasPermission,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // Default permission checker
  const checkPermission = hasPermission || (() => true);

  return (
    <>
      <IconButton onClick={handleOpen} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {checkPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit && onEdit(row);
              handleClose();
            }}
          >
            Edit
          </MenuItem>
        )}
        {checkPermission("delete") && (
          <MenuItem
            onClick={() => {
              onDelete && onDelete(row.service_type_id || row.id);
              handleClose();
            }}
          >
            Delete
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            // create charge for this service type
            onCreateServiceCharge &&
              onCreateServiceCharge(row.service_type_id, row.service_type_name);
            handleClose();
          }}
        >
          Create Charge
        </MenuItem>
        <MenuItem
          onClick={() => {
            onViewServiceCharges &&
              onViewServiceCharges(row.service_type_id, row.service_type_name);
            handleClose();
          }}
        >
          View Charges
        </MenuItem>
      </Menu>
    </>
  );
};

RowServiceTypeActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onCreateServiceCharge: PropTypes.func,
  onViewServiceCharges: PropTypes.func,
  hasPermission: PropTypes.func,
};

export default RowServiceTypeActionsMenu;
